import __request__ from "routing/request";
export function getCertificateInfo(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/config/certinfo", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBackendDetails(backendId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/saml/config/details/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getIdpDefaultAttributeMapping(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/config/idp/default-attribute-mapping", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getIdpMetadata(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/config/idp/metadata", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function generateSpCredentials(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/config/sp/credentials", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
